import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "disabled", "label", "hasError", "hint", "PrefixIcon", "SuffixIcon", "withDivider", "type", "inputProps", "focusColor"];
import clsx from 'clsx';
import React, { forwardRef, useRef } from 'react';
var styles = {
  "hint": "pbui-CKrO2",
  "hint--no-error": "pbui-6kIUW",
  "hint--has-error": "pbui-G2pXE",
  "label": "pbui-Kunxd",
  "container": "pbui-Ut6eR",
  "input__container": "pbui-PM4KV",
  "input__container--disabled": "pbui-9PoPD",
  "input__container--has-error": "pbui-bkbDX",
  "input": "pbui-x7tmo",
  "prefix": "pbui-bEYBP",
  "suffix": "pbui-9cutn",
  "prefix--with-divider": "pbui-AA6VK",
  "suffix--with-divider": "pbui-126C-",
  "input__container--focus-orange": "pbui-c0Lfj"
};
import { InputHint } from './InputHint';
import { InputLabel } from './InputLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var InputField = /*#__PURE__*/forwardRef(function InputField(props, _ref) {
  var className = props.className,
    disabled = props.disabled,
    label = props.label,
    hasError = props.hasError,
    hint = props.hint,
    PrefixIcon = props.PrefixIcon,
    SuffixIcon = props.SuffixIcon,
    withDivider = props.withDivider,
    _props$type = props.type,
    type = _props$type === void 0 ? "text" : _props$type,
    inputProps = props.inputProps,
    _props$focusColor = props.focusColor,
    focusColor = _props$focusColor === void 0 ? "default" : _props$focusColor,
    rest = _objectWithoutProperties(props, _excluded);
  var inputRef = useRef(null);
  var inputContainerClasses = clsx(styles.input__container, className, disabled && styles["input__container--disabled"], hasError && styles["input__container--has-error"], focusColor === "orange" && styles["input__container--focus-orange"]);
  var inputClasses = clsx(styles.input, inputProps == null ? void 0 : inputProps.className);
  var prefixClasses = clsx(styles.prefix, withDivider && styles['prefix--with-divider']);
  var suffixClasses = clsx(styles.suffix, withDivider && styles['suffix--with-divider']);
  var handleIconClick = function handleIconClick() {
    var node = inputRef.current;
    if (node !== null) node.focus();
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    onClick: function onClick() {
      return handleIconClick();
    },
    children: [label && /*#__PURE__*/_jsx(InputLabel, {
      htmlFor: rest.id,
      className: inputProps == null ? void 0 : inputProps.labelClassName,
      children: label
    }), /*#__PURE__*/_jsxs("div", {
      className: inputContainerClasses,
      children: [PrefixIcon && /*#__PURE__*/_jsx("span", {
        className: prefixClasses,
        children: PrefixIcon()
      }), /*#__PURE__*/_jsx("input", _extends({
        type: type,
        ref: function ref(element) {
          inputRef.current = element;
          if (typeof _ref === "function") {
            _ref(element);
          } else if (_ref) {
            _ref.current = element;
          }
        },
        className: inputClasses,
        disabled: disabled,
        autoComplete: "one-time-code"
      }, rest)), SuffixIcon && /*#__PURE__*/_jsx("span", {
        className: suffixClasses,
        children: SuffixIcon()
      })]
    }), hint && /*#__PURE__*/_jsx(InputHint, {
      hasError: hasError,
      children: hint
    })]
  });
});
export default InputField;